exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-control:focus {\n    box-shadow: none;\n }\n\n .search_type_width {\n     flex: 0.3 1 auto !important;\n }", ""]);

